import axios from 'axios';

const ApiKey = 'ea92083762cc1445208ed0f88e2e9a43';

export default class TheMovieDBAPI {
  _instance;

  constructor() {
    this.axiosInstanceInternal = null;
    this.baseURL = 'https://api.themoviedb.org/3/';
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new TheMovieDBAPI();
    }
    return this._instance;
  }

  static reset() {
    TheMovieDBAPI.instance.axiosInstanceInternal = null;
  }

  get axiosInstance() {
    if (this.axiosInstanceInternal === null) {
      this.axiosInstanceInternal = axios.create({
        baseURL: this.baseURL,
      });
      // this.axiosInstanceInternal.defaults.params = {};
      // this.axiosInstanceInternal.defaults.params.api_key = ApiKey;
    }
    return this.axiosInstanceInternal;
  }

  async searchMovies(name) {
    const successResponse = await this.axiosInstance.get('search/movie', {
      params: {
        query: name,
        api_key: ApiKey,
      },
    });
    return successResponse.data;
  }

  async getSimilarMovies(movie, page = 1) {
    const successResponse = await this.axiosInstance.get(`movie/${movie.id}/similar`, {
      params: {
        language: 'en',
        page,
        api_key: ApiKey,
      },
    });
    return successResponse;
  }

  async getMovie(id) {
    const successResponse = await this.axiosInstance.get(`movie/${id}`, {
      params: {
        api_key: ApiKey,
      },
    });
    return successResponse.data;
  }
}
